<hbo-datatable-smart *ngIf="policies$ | async as policies" [typeData]="'policiesList'"
  [columns]="['distributor', 'team', 'packageAvailable', 'licenseAppVisibility']"
  [items]="policies" (reload)="searchPolicies($event)"
  [showTeamFilter]="true" [teams_filter]="teams"
>
  <tbody class="table-group-divider accordion" id="accordionPolicy">
    <ng-container *ngFor="let policy of policiesCollection$">
      <tr class="accordion-header">
        <th scope="row"><button class="accordion-button collapsed" data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse-' + policy.id"> </button></th>
        <td>{{ policy.entity.name }}</td>
        <td>{{ policy.team?.name || '-' }}</td>
        <td>
          <ng-container *ngFor="let packagePolicy of policy.packagePolicies; let last = last">
            {{ packagePolicy.packageType.name }}<ng-container *ngIf="!last">, </ng-container>
          </ng-container>
        </td>
        <td>{{ policy.seeLicenses ? 'Allowed' : 'Not allowed' }}</td>
      </tr>
      <tr class="row-body">
        <td colspan="5" class="bg-light p-0">
          <div [id]="'collapse-' + policy.id" class="accordion-collapse collapse" data-bs-parent="#accordionPolicy">
            <div class="accordion-body">
              <hbo-policy-actions [policy]="policy" (reload)="searchPolicies()" (callback)="callback($event)" [entity]="policy.entity"></hbo-policy-actions>
            </div>
          </div>
        </td>
      </tr>
    </ng-container>
    <tr *ngIf="!policies.data.length">
      <td colspan="5" class="text-center">{{ 'COMMON.NO_RESULTS' | translate }}</td>
    </tr>
  </tbody>
</hbo-datatable-smart>
